const HEADERS = new Headers({
    'X-CSRF-TOKEN': localStorage.getItem('csrf_token') || ''
});

export {
    HEADERS,
}